// 生成文件请勿修改
let API_ENV = "production";
export default API_ENV;